module.exports = __webpack_public_path__ + "static/media/feature-manage1.619b48ed.png";